import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { AppState } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpUtils } from '../../../common/http/http-utils';
import { Dropdown } from '@clr/angular';

import { JobsNotifierService } from '../../services/job-notifier.service';

import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Component({
    selector: 'about',
    styles: [
        require('./about.scss')
    ],
    template: require('./about.html'),
    encapsulation: ViewEncapsulation.None
})

export default class AboutComponent {

    constructor(public appState: AppState, public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    public openLink(url) {
        const win = window.open(url, '_blank');
        win.focus();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/about/about.component.ts